import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { DocumentsService } from './pages/documents/documents.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title: string = 'Roz';
  isUploadingDocuments: boolean = false;
  isCopyingDocuments: boolean = false;

  private isUploadingDocumentsSubscription: Subscription = new Subscription();
  private isCopyingDocumentsSubscription: Subscription = new Subscription();

  constructor(private documentsService: DocumentsService) {
    this.isUploadingDocuments =
      this.documentsService.isUploadingDocuments.value;
    this.isCopyingDocuments = this.documentsService.isCopyingDocuments.value;
  }

  ngOnInit(): void {
    // Suscripción a la variable que indica si se están cargando documentos.
    this.isUploadingDocumentsSubscription =
      this.documentsService.isUploadingDocuments.subscribe(
        (value: boolean): void => {
          this.isUploadingDocuments = value;
        }
      );
    // Suscripción a la variable que indica si se están copiando documentos.
    this.isCopyingDocumentsSubscription =
      this.documentsService.isCopyingDocuments.subscribe(
        (value: boolean): void => {
          this.isCopyingDocuments = value;
        }
      );
    this.initGoogleAnalytics(environment.googleAnalyticsId);
  }

  ngOnDestroy(): void {
    this.isUploadingDocumentsSubscription.unsubscribe();
    this.isCopyingDocumentsSubscription.unsubscribe();
    console.log('app.component subscriptions removed.');
  }

  private initGoogleAnalytics(id: string): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
    const inline = document.createElement('script');
    inline.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}');`;
    document.head.appendChild(inline);
  }
}
